/**   
 * api接口统一管理
 */
import { get, post } from './http'

//注册
export const register = param => post('/api/user/register', param);
//登录
export const login = param => post('/api/user/login', param);
//微信授权传code
export const wxAuthorization = param => get('/api/v1/wechat/user/wcallback', param);
//获取登录用户信息
export const getUserInfo = param => get('/api/user/getUserInfo', param);

//我要反馈
export const saveGuestBook = param => post('/api/user/saveGuestBook', param);
//我的反馈列表
export const myGuestBookList = param => post('/api/user/myGuestBookList', param);
//我的订单查询
export const orderlist = param => post('/api/user/orderlist', param);
//我的收藏
export const getMyColl = param => post('/api/user/getMyColl', param);


//退出登录
export const loginout = param => get('/api/user/loginout', param);
//banner图
export const bannerList = param => post('/api/msg/bannerlist', param);
//首页图文链接
export const linkPicList = param => post('/api/msg/linkPicList', param);
//友情链接
export const linkList = param => post('/api/msg/linklist', param);
//快捷入口
export const fastLink = param => post('/api/msg/fastLink', param);
//关于我们
export const baseInfo = param => get('/api/msg/baseInfo', param);
//发布需求
export const myRequests = param => post('/api/msg/myRequests', param);

//字典列表
export const dictList = param => post('/api/msg/dictlist', param);

//平台大事列表
export const platformEventsList = param => post('/api/msg/platformEventsList', param);
//平台大事详情
export const platformEventsDetail = param => post('/api/msg/platformEvents', param);
//通知公告列表
export const noticeList = param => post('/api/msg/policylist-1', param);
//通知公告详情
export const noticeDetail = param => post('/api/msg/policy', param);
//双创政策列表
export const policyList = param => post('/api/msg/policylist-0', param);
//双创政策详情
export const policyDetail = param => post('/api/msg/policy', param);

//载体平台列表
export const platformList = param => post('/api/msg/platformlist', param);
//载体平台详情
export const platformDetail = param => post('/api/msg/platform', param);

//服务产品列表
export const productList = param => post('/api/msg/productlist', param);
//服务产品详情
export const productDetail = param => post('/api/msg/product', param);

//专家导师列表
export const expertList = param => post('/api/msg/expertlist', param);
//专家导师详情
export const expertDetail = param => post('/api/msg/expert', param);

//高层次人才列表
export const personList = param => post('/api/msg/hightTalentsList', param);
//高层次人才详情
export const personDetail = param => post('/api/msg/hightTalents', param);

//双创项目列表
export const projectList = param => post('/api/msg/projectlist', param);
//双创项目详情
export const projectDetail = param => post('/api/msg/project', param);

//技术成果列表
export const achievementsList = param => post('/api/msg/achievementslist', param);
//技术成果详情
export const achievementsDetail = param => post('/api/msg/achievements', param);

/*9-25修改之后start**/
//金融产品列表
export const carrierlist = param => post('/api/msg/carrierlist', param);
//金融产品详情
export const carrierDetail = param => post('/api/msg/carrier', param);
/*9-25修改之后end**/

//双创活动列表
export const activityList = param => post('/api/msg/activitylist', param);
//双创活动详情
export const activityDetail = param => post('/api/msg/activity', param);
//双创活动报名支付后订单
export const activityOrderDetail = param => post('/api/user/showSignPayResult', param);

//收藏
export const saveColl = param => post('/api/user/saveColl', param);

//活动报名
export const signActivity = param => post('/api/user/signActivity', param);

//收藏
export const collectionLight = param => post('/api/user/collectionLight', param);

//取消收藏
export const cancelColl = param => post('/api/user/cancelColl', param);

//商品支付
export const buyProduct = param => post('/api/v1/wechat/buyProduct', param);

//商品支付详情
export const showPayResult = param => post('/api/v1/wechat/showPayResult', param);

//入驻申请
export const residenceApplication = param => post('/api/msg/residenceApplication', param);



// WEBPACK FOOTER //
// ./src/api.js